export default {
  FETCH_STORE_LOCATOR_SUCCESS: 'FETCH_STORE_LOCATOR_SUCCESS',
  UPDATE_STORE_LOCATOR_SUCCESS: 'UPDATE_STORE_LOCATOR_SUCCESS',
}



// WEBPACK FOOTER //
// ./src/store/storeLocator/types.js